import React from 'react';
import './Chapters.scss';
import graphic from '../../assets/inlinePhoto3.svg';

function Chapter3() {
  return (
    <section className="chapter">
      <h3 className="chapter__title">Using AI to Predict Supply and Demand</h3>
      <p className="chapter__paragraph">
        Once food donations arrive at FareShare GM, some of the organization’s nearly 200 local
        volunteers spring into action. A few of these volunteers have forklift licenses, which
        proves helpful in unloading the donations from the trucks, but much of the labor is
        performed manually as volunteers unload goods, enter the donations into a database, and
        start sorting and packing food for delivery and distribution to a network of charity
        partners.
      </p>
      <p className="chapter__paragraph">
        Every aspect of the daily tasks is staggering. FareShare has more than 30 warehouses in its
        network and supports over 10,000 charities in the UK, including regional charities, schools,
        and other community food members (CFMs) who depend on FareShare to stave off hunger. In
        2021, the FareShare UK network provided enough food through its charity partners across the
        country for 132 million meals, which equates to a meal every four seconds throughout the
        entire year. Nationally, the organization has supplied more than 54,200 metric tons of food
        in 2021, which amounts to more than 148 metric tons per day, representing more than twice as
        much food as FareShare distributed the prior year throughout the country.
      </p>
      <img src={graphic} alt="graphic" />
    </section>
  );
}

export default Chapter3;
